<template lang="pug">
.new-simulation-form
  .card-box
    .row
      .col-md-9.col-sm-12
        h3.text-dark.site-title.m-t-m-b-30
          span {{ $t('formTitle') }}
        p
          span {{ $t('taglineBefore') }}
          a(href="https://www.ideamans.com/lp1/lightfile-bot/").m-r-5.m-l-5 {{ $t('taglineLink') }}
          span {{ $t('taglineAfter') }}
        .m-t-30
        .form-group
          label
            | {{ $t('pageUrl') }}
            span.badge.badge-danger.m-l-5 {{ $t('Required') }}
          input.form-control(type="url" name="url" v-bind:class="{'is-invalid': errors.has('url')}" v-validate="'required|url'" v-model.lazy="url" placeholder="https://www.ideamans.com/" lazy)
          .invalid-feedback(v-if="errors.has('url')") {{ errors.first('url') }}

        .form-group
          .form-check.form-check-inline
            label
              input.form-check-input(type="radio" value="sp" v-model="device")
              i.mdi.mdi-cellphone-iphone.m-r-5
              | {{ $t('asSmartPhone') }}
            label.m-l-10
              input.form-check-input(type="radio" value="pc" v-model="device")
              i.mdi.mdi-laptop.m-r-5
              | {{ $t('asPCBrowser') }}

        .form-group
          label
            | {{ $t('email') }}
            span.badge.badge-danger.m-l-5 {{ $t('Required') }}
          input.form-control(type="email" name="email" v-bind:class="{'is-invalid': errors.has('email')}" v-validate="'required|email'" v-model.lazy="email" placeholder="your@example.com" lazy)
          .invalid-feedback(v-if="errors.has('email')") {{ errors.first('email') }}
          small.text-hint
            | {{ $t('emailReason') }}

        .form-group
          label
            | {{ $t('simulationType') }}
            span.badge.badge-danger.m-l-5 {{ $t('Required') }}
          .form-check(v-for="i in ['lightfile', /* 'lightfileonly' */]")
            label
              input.m-r-5.form-check-input(type="radio" v-bind:value="i" v-model="intent")
              span.badge.badge-primary.m-r-5(v-if="i == 'lightfile'") {{ $t('recommend') }}
              strong.m-r-5 {{ $t(`simulations.${i}.reportTitle`) }}
              small {{ $t(`${i}Desc`) }}

        .form-group
          label
            | {{ $t('simulationWithWebp') }}
            small ({{ $t('webpRequiresServerConfig') }})
          .form-check(v-for="i in ['lightfilewebp' /* , 'webponly' */]")
            label
              input.m-r-5.form-check-input(type="radio" v-bind:value="i" v-model="intent")
              strong.m-r-5 {{ $t(`simulations.${i}.reportTitle`) }}
              small {{ $t(`${i}Desc`) }}

        .form-group
          label
            | {{ $t('forUsers') }}
          .form-check(v-for="i in [/*'subscription', */ 'unsubscribe']")
            label
              input.m-r-5.form-check-input(type="radio" v-bind:value="i" v-model="intent")
              strong.m-r-5 {{ $t(`simulations.${i}.reportTitle`) }}
              small {{ $t(`${i}Desc`) }}

        .m-t-30
          input(type="hidden" v-model="ip")
          button.btn.btn-lg.btn-primary(v-on:click="start")
            | {{ $t('startSimulation') }}
            i.mdi.mdi-arrow-right
      .col-md-3.d-none.d-md-block.text-center
        router-link(to="/reports/dd922a57-e3e2-4900-8bd9-4217abc74ebd")
          span.m-b-10.badge.badge-dark
            | {{ $t('reportExample') }}
            i.mdi.mdi-arrow-right.m-l-5
          img.img-responsive.img-thumbnail(src="example.png")
</template>

<i18n>
{
  "ja": {
    "formTitle": "Webページの画像をどれだけ軽量化できるか無料でレポート",
    "taglineBefore": "このツールは",
    "taglineLink": "Webサイトの画像軽量化ソリューションLightFile",
    "taglineAfter": "の導入成果を事前に確認するためのシミュレーターです。",
    "pageUrl": "チェックするページのURL",
    "asSmartPhone": "スマートフォンとしてアクセス",
    "asPCBrowser": "PCブラウザとしてアクセス",
    "email": "通知先メールアドレス",
    "emailReason": "チェックに時間がかかる場合があります。メールアドレスを入力いただくと、レポート完成時にお知らせします。",
    "startSimulation": "シミュレーション開始",
    "simulationType": "どのようなシミュレーションを実行しますか？",
    "simulationWithWebp": "LightFileは次世代画像フォーマットWebPにも対応しています",
    "webpRequiresServerConfig": "WebPの利用にはWebサーバーの設定変更が必要です",
    "forUsers": "すでにご利用のお客様へ",
    "recommend": "おすすめ",
    "lightfileonlyDesc": "LightFile単独でどのくらい軽量化できるかシミュレーションします(容量優先)。",
    "webponlyDesc": "WebP単独でどのくらい軽量化できるかシミュレーションします。",
    "lightfilewebpDesc": "LightFileとWebP、その併用でどのくらい軽量化できるかシミュレーションします。",
    "lightfileDesc": "LightFileの導入成果を品質パラメータごとにシミュレーションします。",
    "subscriptionDesc": "実際にどのくらい画像が軽量化されたかレポートします。",
    "unsubscribeDesc": "LightFileを解約するとどのくらい画像データが増加するかレポートします。",
    "lightFileSimulation": "LightFileを導入したらどのくらい画像を軽量化できるか",
    "lightFileAndWebp": "LightFileとWebPを併用したらどのくらい画像を軽量化できるか",
    "lightFileRemove": "LightFileを利用中で終了するとどのくらい画像データ量が増えるか",
    "reportExample": "レポートの例"
  }
}</i18n>

<script>
import Lib from "@/lib";
import * as Axios from "axios";

export default {
  data() {
    return {
      url: "",
      ip: "",
      device: "sp",
      intent: "lightfile",
      email: ""
    };
  },
  methods: {
    start: async function() {
      const app = new Lib.App();

      const validation = await this.$validator.validateAll();
      if (!validation) {
        return;
      }

      const task = await app.sendNewSimulationTask({
        url: this.url,
        ip: this.ip,
        device: this.device,
        email: this.email,
        intent: this.intent
      });

      this.$router.push({ name: "report", params: { id: task.id } });
    }
  },
  created() {
    this.url = window.localStorage.getItem("url") || "";
    this.email = window.localStorage.getItem("email") || "";
    this.device = window.localStorage.getItem("device") || "sp";
    this.intent = window.localStorage.getItem("intent") || "lightfile";

    Axios.get("https://mautic-gateway.ideamans.com/me")
      .catch(ex => console.error(ex))
      .then(res => {
        this.ip = res.data.ip;
      });
  },
  watch: {
    url() {
      window.localStorage.setItem("url", this.url);
    },
    email() {
      window.localStorage.setItem("email", this.email);
    },
    device() {
      window.localStorage.setItem("device", this.device);
    },
    intent() {
      window.localStorage.setItem("intent", this.intent);
    }
  }
};
</script>
